import React, { useState } from 'react';
import { isEmpty, isNil } from 'lodash';

import './RandomButtonPicker.scss';

const RandomButtonPicker = ({ links, buttonText }) => {
    const randomNumber = (max) => Math.floor(Math.random() * max);
    const randomElementLink = () => {
        if (isNil(links) || isEmpty(links)) return '#';
        const idx = randomNumber(links.length);
        return links[idx];
    };
    const [link, setLink] = useState(randomElementLink());

    return (
        <div className='button-container'>
            <a
                className='button button--primary'
                href={link}
                title={buttonText}
                onClick={() => {
                    setLink(randomElementLink());
                }}
                target='_blank'>
                {buttonText}
            </a>
        </div>
    );
};

export default RandomButtonPicker;
